import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/specific-heat-calculator',
  component: () => import('../../routes/SpecificHeatCalculator.svelte'),
  card: {
    id: 'specific-heat-calculator',
    title: 'Specific Heat Calculator',
    description: 'Calculate heat energy, mass, specific heat capacity, or temperature change using the Q = m·c·ΔT formula. Enter any three values to find the fourth. Includes 16 material presets (water, copper, aluminum, iron, and more).',
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/specific-heat-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Specific Heat Calculator – Q = m·c·ΔT Formula',
    description:
      'Free specific heat calculator to find heat energy, mass, specific heat capacity, or temperature change using Q = m·c·ΔT. Includes material presets (water, copper, aluminum, iron, lead, gold, and more). Solves for any variable.',
  },
};

export default meta;
